import { render, staticRenderFns } from "./homepage.tw.vue?vue&type=template&id=f09e5476&scoped=true"
import script from "./homepage.tw.vue?vue&type=script&lang=js"
export * from "./homepage.tw.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f09e5476",
  null
  
)

export default component.exports